<template>
  <b-modal
    v-model="localShowDetailModal"
    centered
    :title="modalTitle"
    @hide="$emit('close')"
    hide-header-close
  >
    <div v-if="selectedItems" class="d-flex flex-column gap-3">
      <span>{{ modalMessage }}</span>
      <ul style="max-height: 300px; overflow-y: auto">
        <li v-for="item in selectedItems || []" :key="item.id">
          {{ item?.training?.title || item?.coaching?.title || item?.id }}
          <small
            v-if="!isReject && learningType === 'structured_learning'"
            class="d-block text-muted"
          >
            Next step: {{ getNextApproverLabel(item) }}
          </small>
        </li>
      </ul>
    </div>

    <template #modal-footer>
      <div class="d-flex justify-content-between align-items-center w-100">
        <!-- <div v-if="!isReject" class="text-danger small">
          <i class="fe fe-alert-circle"></i>
          <span>
            Other
            {{
              learningType === "structured_learning"
                ? "trainings"
                : "coaching / mentoring"
            }}
            except the above mentioned data will be automatically rejected.
          </span>
        </div>
        <div v-else></div> -->
        <b-button
          :variant="isReject ? 'danger' : 'primary'"
          :disabled="isSubmitting"
          @click="handleSubmit"
        >
          {{ isReject ? "Reject" : "Approve" }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { titleCase } from "@/utils/titleCase";
import { getNextApproverLabel } from "@/utils/approvalStatus";

export default {
  name: "ConfirmationSubmitModal",
  props: {
    showConfirmationSubmit: {
      type: Boolean,
      default: false,
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    learningType: { type: String, default: "structured_learning" },
    isReject: { type: Boolean, default: false },
  },
  computed: {
    localShowDetailModal: {
      get() {
        return this.showConfirmationSubmit;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    modalTitle() {
      const action = this.isReject ? "Tolak" : "Setujui";
      const type =
        this.learningType === "structured_learning" ? "Pelatihan" : "Coaching";
      return `${action} ${type}`;
    },
    modalMessage() {
      if (this.isReject) {
        return this.learningType === "structured_learning"
          ? "Apakah Anda yakin ingin menolak pelatihan ini?"
          : "Apakah Anda yakin ingin menolak coaching / mentoring ini?";
      }
      return this.learningType === "structured_learning"
        ? "Apakah Anda yakin ingin menyetujui pelatihan ini?"
        : "Apakah Anda yakin ingin menyetujui coaching / mentoring ini?";
    },
  },
  methods: {
    titleCase,
    getNextApproverLabel,
    handleSubmit() {
      const ids = this.selectedItems.map((row) => row.id);

      this.$emit("submit", ids);
    },
  },
};
</script>

<style scoped>
.gap-2 > * + * {
  margin-left: 0.5rem;
}

.table td {
  padding: 0.5rem 0;
}

.d-flex.flex-wrap {
  row-gap: 0.25rem;
  column-gap: 0.25rem;
}

.completion-badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>
